import { render } from "./box-arrow-up-right.vue?vue&type=template&id=b321404c"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/box-arrow-up-right.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b321404c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b321404c', __exports__)) {
    api.reload('b321404c', __exports__)
  }
  
  module.hot.accept("./box-arrow-up-right.vue?vue&type=template&id=b321404c", () => {
    api.rerender('b321404c', render)
  })

}


export default __exports__